import React from 'react';

export const Chip = ({
  icon,
  number,
  label,
  className,
  subtext,
}: {
  icon: string;
  number: string | number;
  label: string;
  className?: string;
  subtext?: string;
}) => {
  return (
    <div
      className={`bg-white rounded-md p-8 shadow-sm mr-32 flex items-center ${className}`}
      style={{ width: '243px', minWidth: '243px' }}
    >
      <div className="text-lg bg-primary-100 flex justify-center items-center p-16 w-38 h-38 rounded-md mr-16">
        {icon}
      </div>
      <div className="">
        <div className="text-xl font-bold flex items-baseline">
          {number} <span className="text-xs font-thin pl-8 text-gray-500">{subtext}</span>
        </div>
        <div className="font-medium text-xs text-gray-600">{label}</div>
      </div>
    </div>
  );
};

export const PlaceholderChip = ({ className }: { className?: string }) => {
  return (
    <div
      className={`bg-gray-200 rounded-md p-8 shadow-sm mr-32 flex items-center animate-pulse ${className}`}
      style={{ width: '243px', minWidth: '243px' }}
    >
      <div className="text-lg bg-primary-100 flex justify-center items-center p-16 w-38 h-38 rounded-md mr-16"></div>
      <div className="">
        <div className="text-xl font-bold flex items-baseline">
          <span className="text-xs font-thin pl-8 text-gray-500"></span>
        </div>
        <div className="font-medium text-xs text-gray-600"></div>
      </div>
    </div>
  );
};
